import { UseQueryDefaultOptions } from '@front/hook/Api/common';
import { DEFAULT_TIMEOUT } from '@front/hook/Api/utils/consts';
import { signalToTimeout } from '@front/hook/Api/utils/signalToTimeout';
import { ImportTaskRepository } from '@front/repository/Api/ImportTask';
import { useQuery } from '@tanstack/react-query';
import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import ImportTask = DomainV2.Import.ImportTask;

import { importTaskQueryKeys } from './queryKeys';

const repository = new ImportTaskRepository();

type Params = {
  projectId: Project.Id;
  id: ImportTask.Id | undefined;
};

type Options = {
  enabled?: boolean;
  /** 未完了タスクの間だけ指定間隔（ms）で再取得する */
  pollIntervalMs?: number;
};

export const _get = ({ projectId, id }: Params, options?: Options) => {
  const pollIntervalMs = options?.pollIntervalMs;

  return useQuery({
    queryKey:
      id !== undefined ? importTaskQueryKeys.detail(projectId, id) : (['troppus', 'importTask', 'detail', projectId, 'pending'] as const),
    queryFn: async ({ signal }) => {
      if (id === undefined) return undefined;
      return repository.get({ projectId, id }, { signal: signalToTimeout(DEFAULT_TIMEOUT.QUERY, signal) });
    },
    enabled: (options?.enabled ?? true) && id !== undefined,
    ...UseQueryDefaultOptions,
    refetchInterval: (query) => {
      if (pollIntervalMs === undefined) return false;
      const task = query.state.data;
      if (!task) return false;
      const isIncomplete = task.status === 'Requested' || task.status === 'Started';
      return isIncomplete ? pollIntervalMs : false;
    },
    refetchIntervalInBackground: false,
  });
};
